






















































import TitleBase from '@/components/atoms/TitleBase.vue'
import TitleTextBase from '@/components/atoms/TitleTextBase.vue'
import ColoredBox from '@/components/atoms/ColoredBox.vue'
import SelectBase from '@/components/atoms/SelectBase.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import SelectCoursesAlignedTable from '@/components/organisms/SelectCoursesAlignedTable.vue'
import QueryMethods from '@/components/atoms/QueryMethods.vue'
import SelectCoursesStandardTable from '@/components/organisms/SelectCoursesStandardTable.vue'
import { Component, Vue, Ref, Mixins } from 'vue-property-decorator'
import { GRADE_IDS_OPTIONS, TEACHER_SETTING_TEXT } from '@/constants'
import { AlignedCourses, StandardCourses } from '@/store/modules/StudentCreationInfo'
import StudentIdsInfo from './StudentIdsInfo.vue'
import { StudentInfo as StudentInfoI } from '@/store/modules/StudentCreationInfo'
import { StudentResponseType } from '@/models/api/students'
import { CourseResponse } from '@/components/organisms/v3/ModalStudentCourses.vue'
import dayjs from 'dayjs'

@Component({
  components: {
    TitleBase,
    TitleTextBase,
    ColoredBox,
    SelectBase,
    ButtonBase,
    SelectCoursesAlignedTable,
    SelectCoursesStandardTable,
  },
})
export default class StudentInfo extends Mixins(QueryMethods, StudentIdsInfo) {
  @Ref() selectCoursesTable!: SelectCoursesAlignedTable
  private breadcrumbs = [
    { text: TEACHER_SETTING_TEXT, href: '/teacher/setting/top' },
    { text: '生徒', href: '/teacher/setting/v3/student' },
    { text: '生徒新規追加', active: true },
  ]

  private nickname = ''
  private studentCode = ''
  private schoolSelected = ''
  private gradeSelected = ''
  private alignedCourses: AlignedCourses | null = null
  private standardCourses: StandardCourses = {}
  private studentId: null | number = null
  private alignedCoursesDefault: CourseResponse | null = null
  private standardCoursesDefault: CourseResponse | null = null

  private get nameErrors(): string[] {
    if (!this.nickname) return []
    return this.nickname.length > 20 ? ['氏名は20文字までです'] : []
  }

  private get codeErrors(): string[] {
    const errors: string[] = []
    if (!this.studentCode) {
      return errors
    }
    if (this.studentCode.length > 20) {
      errors.push('生徒IDは20文字までです')
    }
    if (!this.studentCode.match(/^[0-9a-zA-Z]*$/)) {
      errors.push('生徒IDは半角英数字で入力してください')
    }
    return errors
  }

  private get colortype(): string {
    const isCourseSelected =
      this.isChooseAlignedCourses(this.alignedCourses) || this.isChooseStandardCourses(this.standardCourses)

    const isFormValid =
      this.nickname &&
      !this.nameErrors.length &&
      this.studentCode &&
      !this.codeErrors.length &&
      this.schoolSelected &&
      this.gradeSelected

    return (isFormValid && isCourseSelected) || (this.isMultiStudent && isCourseSelected)
      ? 'blue'
      : 'pointer-events-none'
  }

  private onCourseAlignedChange(courseSelected: AlignedCourses) {
    this.alignedCourses = courseSelected
  }
  private onCourseStandardChange(courseSelected: StandardCourses) {
    this.standardCourses = courseSelected
  }

  private gradeOptions = GRADE_IDS_OPTIONS

  private handleSubmit() {
    this.$store.commit('studentCreationInfo/setStudentInfo', {
      nickname: this.nickname,
      studentCode: this.studentCode,
      schoolSelected: this.schoolSelected,
      gradeSelected: this.gradeSelected,
      standardCourses: this.standardCourses,
      alignedCourses: this.alignedCourses,
    })

    const userIds = this.userIds.join(',')
    const studentId = this.studentId || this.getParamsObject()['studentId'] || ''
    const route = this.isChooseAlignedCourses(this.alignedCourses)
      ? `/teacher/setting/v3/student/create/date?id=${userIds}&studentId=${studentId}`
      : `/teacher/setting/v3/student/create/confirm?id=${userIds}&studentId=${studentId}`

    this.$router.push(route)
  }

  private async getStudentsInfo() {
    await Vue.prototype.$http.httpWithToken
      .get(`/v3/students`, { params: { branchId: this.branchId, userId: this.userIds.join(',') } })
      .then((res: any) => {
        const student: StudentResponseType = res.data.students[0]
        this.setStudentInfoDefault({
          nickname: student.nickname,
          studentCode: student.studentCode,
          schoolSelected: String(student.schoolId),
          gradeSelected: String(student.gradeId),
        })
        this.studentId = student.studentId
      })
  }

  private setStudentInfoDefault(studentInfo: StudentInfoI) {
    this.nickname = studentInfo.nickname ?? ''
    this.studentCode = studentInfo.studentCode ?? ''
    this.schoolSelected = studentInfo.schoolSelected ?? ''
    this.gradeSelected = studentInfo.gradeSelected ?? ''
  }

  private async fetchCourses() {
    await Vue.prototype.$http.httpWithToken
      .get(`/v3/students/${this.studentId}/courses`)
      .then((res: { data: CourseResponse[] }) => {
        const data = res.data
        this.alignedCoursesDefault = data.find((course) => course.courseType === 'aligned') || null
        this.standardCoursesDefault = data.find((course) => course.courseType === 'standard') || null
        const firstAlignedData = this.alignedCoursesDefault?.courseData[0]
        if (firstAlignedData) {
          const startDate = dayjs(firstAlignedData.startDate)
          const endDate = dayjs(firstAlignedData.endDate)
          const month = endDate.diff(startDate, 'month') + 1

          this.$store.commit('studentCreationInfo/setStudentInfo', {
            date: startDate.format('YYYY/MM/DD'),
            month,
          })
        }
      })
  }

  private async mounted() {
    Vue.prototype.$loading.start()
    const studentInfo = this.$store.state.studentCreationInfo.studentInfo
    await this.setParamsFromQuery()
    await this.loadSchools()
    if (this.userIds.length === 1 && !studentInfo.nickname) {
      await this.getStudentsInfo()
      await this.fetchCourses()
    } else {
      this.setStudentInfoDefault(studentInfo)
    }
    Vue.prototype.$loading.complete()
  }
}
